import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { EditButton } from '../EditButtonStyle.styles';
import FieldDetail from '../FieldDetail';
import MoneyDetail from '../MoneyDetail';

export default function TransactionDetail({
  hasEdit,
  amount,
  fee,
  dateInitiated,
  timeline,
  transferType,
  transactionDescription,
  wireDate,
  status,
  transactionNumber,
  handleEdit,
  subTitle,
  title = 'Transaction details'
}) {
  return (
    <Grid
      columnSpacing="8px"
      container
      pb={{ xs: '24px', lg: '56px' }}
      pt={{ xs: '24px', lg: '32px' }}
      px={{ xs: '24px', lg: '32px' }}
      rowSpacing={{ xs: '16px', lg: '32px' }}
    >
      <Grid
        item
        xs={12}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Text
            color="primary"
            size="xl"
            weight="medium"
          >
            {title}
          </Text>
          {hasEdit && (
            <EditButton
              color="info"
              onClick={handleEdit}
              size="small"
              sx={{ padding: 0, height: 'auto' }}
              variant="text"
            >
              Edit
            </EditButton>
          )}
        </Stack>
        {subTitle && (
          <Text
            align="left"
            color="secondary"
            size="lg"
          >
            {subTitle}
          </Text>
        )}
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Grid container>
          <MoneyDetail
            label="Amount"
            value={amount}
          />
          <MoneyDetail
            label="Fee"
            value={fee}
          />
        </Grid>
      </Grid>
      <FieldDetail
        label="Date initiated"
        value={dateInitiated}
      />
      <FieldDetail
        label="Wire date"
        value={wireDate}
      />
      <FieldDetail
        label="Timeline"
        value={timeline}
      />
      <FieldDetail
        label="Transfer type"
        value={transferType}
      />
      <FieldDetail
        label="Transaction Description"
        value={transactionDescription}
      />
      <FieldDetail
        label="Status"
        value={status}
      />
      <FieldDetail
        label="Transaction number"
        value={transactionNumber}
      />
    </Grid>
  );
}

TransactionDetail.propTypes = {
  hasEdit: PropTypes.bool,
  amount: PropTypes.string,
  fee: PropTypes.string,
  dateInitiated: PropTypes.string,
  timeline: PropTypes.string,
  transferType: PropTypes.string,
  transactionDescription: PropTypes.string,
  wireDate: PropTypes.string,
  status: PropTypes.string,
  transactionNumber: PropTypes.string,
  handleEdit: PropTypes.func,
  subTitle: PropTypes.string,
  title: PropTypes.string
};
